import React from 'react'
import { Layout, Space } from 'antd'
import { Content, Footer } from 'antd/es/layout/layout'
import { Link } from 'react-router-dom'
import Routes from '../../constants/routes'

const NotAuthorizedLayoutComponent = ({ children, showFooter = true }) => {
    return (
        <Layout style={{ minHeight: '100vh' }}>
            <Layout className='site-layout'>
                <Content className='d-flex flex-column'>{children}</Content>
                {showFooter ? (
                    <Footer style={{ textAlign: 'center' }}>
                        <Space size='middle'>
                            <Link to={Routes.TERMS_OF_USE}>Terms</Link>
                            <Link to={Routes.PRIVACY_POLICY}>Privacy</Link>
                            <Link to={Routes.ACCESSIBILITY}>Accessibility</Link>
                        </Space>
                    </Footer>
                ) : null}
            </Layout>
        </Layout>
    )
}

const NotAuthorizedLayout = NotAuthorizedLayoutComponent
export default NotAuthorizedLayout
